import {Pipe,PipeTransform} from '@angular/core';

@Pipe({
    name:'ParamListKeyTranslatePipe',
    pure:true
})

export class ParamListKeyTranslatePipe implements PipeTransform {
    transform(paramListKey:string,workoutId:string):string{
		let translateKey = "";
		if(paramListKey === "1"){
			translateKey = "AGE";
		}
		if(paramListKey === "2"){
			translateKey = "WEIGHT";
		}
		if(paramListKey === "3"){
			translateKey = "GENDER";
		}
		if(paramListKey === "4"){
			translateKey = "DISTANCE";
		}
		if(paramListKey === "5"){
			translateKey = "CALORIES";
		}
		if(paramListKey === "6"){
			translateKey = "PACE";
		}
		if(paramListKey === "7"){
			translateKey = "TIME";
		}
		if(paramListKey === "8"){
			translateKey = "TIME.IN.ZONE";
		}
		if(paramListKey === "9"){
			translateKey = "ELEVATION";
		}
		if(paramListKey === "10"){
			translateKey = "MARATHON.MODE";
		}
		if(paramListKey === "11"){
			translateKey = "INCLINE";
		}

		if(paramListKey === "12"){
			if(workoutId === "1005") {
				translateKey = "INITIAL.LEVEL";
			} else {
				translateKey = "LEVEL";
			}
		}
		if(paramListKey === "13"){
			translateKey = "TARGET.HEART.RATE";
		}
		if(paramListKey === "14"){
			translateKey = "INITIAL.SPEED";
		}
		if(paramListKey === "15"){
			translateKey = "WALK.SPEED";
		}
		if(paramListKey === "16"){
			translateKey = "JOG.SPEED";
		}
		if(paramListKey === "17"){
			translateKey = "RUN.SPEED";
		}
		if(paramListKey === "18"){
			translateKey = "TIME.DISTANCE";
		}
		if(paramListKey === "19"){
			translateKey = "PACE.TIME";
		}
		if(paramListKey === "20"){
			translateKey = "AVG.PACE";
		}
		if(paramListKey === "21"){
			if(workoutId === "1004" || workoutId === "1006"){
				translateKey = "CLIMB"
			}else{
				translateKey = "DISTANCE.CLIMBED";
			}			
		}
		if(paramListKey === "22"){
			translateKey = "FLOORS.CLIMBED";
		}
		if(paramListKey === "23"){
			translateKey = "INTERVAL";
		}
		if(paramListKey === "24"){
			translateKey = "WATTS";
		}
		if(paramListKey === "25"){
			translateKey = "METS";
		}
		if(paramListKey === "26"){
			translateKey = "ACTIVITY";
		}
		if(paramListKey === "27"){
			translateKey = "HEIGHT";
		}
		if(paramListKey === "28"){
			translateKey = "RANK";
		}
		if(paramListKey === "29"){
			translateKey = "SCORE";
		}
		if(paramListKey === "30"){
			translateKey = "RUN.TIME";
		}
		if(paramListKey === "31"){
			translateKey = "TEST.TYPE";
		}
		if(paramListKey === "40"){
			translateKey = "TERRAIN";
		}
		if(paramListKey === "41"){
			translateKey = "WORKOUT";
		}
		return translateKey;
    }
}